import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class DetailTrainingServices {
  getDetailTraining = (params, isEvaluable) =>
    AxiosClient.get("/api/app/monitor_capacitaciones/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getDetailTrainingById = id =>
    AxiosClient.get(`/api/app/monitor_capacitaciones/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveDetailTraining = data =>
    AxiosClient.post("/api/app/monitor_capacitaciones/", data, {
      headers: { "Content-Type": "application/json" },
    });
  saveArchive = data =>
    AxiosClient.post("/api/app/capacitacion_archivo_gestor_formatos/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editArchive = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_archivo_gestor_formatos/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editDetailTraining = (id, data) =>
    AxiosClient.put(
      `/api/app/monitor_capacitaciones/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteDetailTraining = id =>
    AxiosClient.delete(`/api/app/monitor_capacitaciones/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new DetailTrainingServices();